<template>
  <div>
    <div class="panel m-3">
      <PanelHeader :panel-header="district ? district.attributes.name : 'Landkreis'" />
      <div class="container pt-3 pb-3">
        <div
          v-if="district && hasContactData"
          class="stammdaten"
        >
          <div class="stammdaten-facts">
            <p v-if="email">
              {{ email }}
            </p>
            <p v-if="phone1Line">
              {{ phone1Line }}
            </p>
            <p v-if="phone2Line">
              {{ phone2Line }}
            </p>
            <p v-if="addressLine">
              {{ addressLine }}
            </p>
          </div>
        </div>
        <div
          v-else
          class="stammdaten"
        >
          <div class="stammdaten-facts">
            <p>Keine weiteren Daten erfasst.</p>
          </div>
        </div>
      </div>
    </div>
    <section class="mx-5 my-2">
      <div
        class="buttons"
        style="display: flex"
      >
        <b-button
          class="is-primary"
          tag="router-link"
          to="/districts"
        >
          Zurück
        </b-button>
        <b-button
          class="is-danger"
          style="margin-left: auto"
          @click="isDeleteCheck = true"
        >
          Löschen
        </b-button>
        <b-button
          class="is-primary"
          @click="triggerEdit"
        >
          Bearbeiten
        </b-button>
      </div>
    </section>
    <ModalComponent
      v-if="isDeleteCheck && district"
      :item="district.attributes.name"
      :is-delete-check="isDeleteCheck"
      :is-loading="isLoading"
      :cancel="() => isDeleteCheck = false"
      :submit="submitDelete"
    />
  </div>
</template>

<script>
import Parse from "parse/dist/parse.min.js";
import PanelHeader from "@/components/helperComponents/PanelHeader";
import ModalComponent from "@/components/helperComponents/ModalComponent";
import { positiveFeedBack } from "@/lib/Toast";
export default {
	name: "ViewDistrict",
	components: {ModalComponent, PanelHeader},
	data(){
		return{
			district: undefined,
			isDeleteCheck: false,
			isLoading: false
		}
	},
	computed: {
		email() {
			const email = this.district && this.district.attributes.email;
			return email ? email.trim() : "";
		},
		phone1Line() {
			if (!this.district) return "";
			const a = this.district.attributes;
			return this.formatPhone(a.phone1, a.info1);
		},
		phone2Line() {
			if (!this.district) return "";
			const a = this.district.attributes;
			return this.formatPhone(a.phone2, a.info2);
		},
		addressLine() {
			if (!this.district) return "";
			const a = this.district.attributes;
			const city = [ a.plz, a.location ]
				.filter(Boolean).map(s => s.trim()).filter(Boolean).join(" ");
			const street = a.street ? a.street.trim() : "";
			return [ street, city ].filter(Boolean).join(", ");
		},
		hasContactData() {
			return !!(this.email || this.phone1Line || this.phone2Line ||
				this.addressLine);
		}
	},
	async mounted() {
		this.district = this.$route.params.data;
		// Reached via browser navigation (back/forward, reload, deep
		// link): the in-memory object is gone, load it by the URL id.
		if (!this.district && this.$route.params.id) {
			try {
				this.district =
					await new Parse.Query("Location").get(this.$route.params.id);
			}
			catch (e) {
				console.error(e);
			}
		}
		if (!this.district) return await this.$router.push({path: "/districts"});
	},
	methods: {
		formatPhone(phone, info) {
			phone = phone ? phone.trim() : "";
			info = info ? info.trim() : "";
			if (!phone) return "";
			return info ? `${phone} (${info})` : phone;
		},
		triggerEdit() {
			this.$router.push(
				{ name: "AddDistrict", params: { data: this.district } });
		},
		async submitDelete() {
			this.isLoading = true;
			const name = this.district.attributes.name;
			this.district.set("deleted", true);
			await this.district.save();
			this.isDeleteCheck = false;
			this.isLoading = false;
			await this.$router.push({path: "/districts"});
			await positiveFeedBack(name + " gelöscht!");
		}
	}
}
</script>

<style scoped>
.stammdaten {
	display: flex;
	align-items: flex-start;
	gap: 1.5rem;
	padding-left: 1.5rem;
}

.stammdaten-facts {
	text-align: left;
	min-width: 0;
}

.stammdaten-facts p {
	margin-bottom: 0.25rem;
}
</style>
